import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Store } from '@ngrx/store';
import { State } from '@completion/reducers';
import { NotificationService } from '../../services/notification.service';
import { SystemService } from '@completion/services';
import { LoadSystemScopeOfWork, LoadSystemScopeOfWorkSuccess, SystemActionTypes } from '@completion/actions';
import { withLatestFrom } from 'rxjs/operators';
import { getCurrentProject } from '@completion/selectors';
import { Observable } from 'rxjs';
import { Project } from '@completion/models';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class SystemEffect {
  constructor(
    private readonly actions$: Actions,
    private readonly systemService: SystemService,
    private readonly store: Store<State>,
    private readonly toastr: NotificationService,
  ) {}

  loadSystemScopeOfWork$ = createEffect(() =>
    this.actions$.pipe(
      ofType<LoadSystemScopeOfWork>(SystemActionTypes.LoadSystemScopeOfWork),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        toastr: this.toastr,
        service: this.systemService,
        method: 'getSystemScopeOfWork',
        serviceArgs: ([action, currentProject]: [LoadSystemScopeOfWork, Project]) => [currentProject?.id, action?.systemId],
        onSuccess: (response) => new LoadSystemScopeOfWorkSuccess(response as any),
      }),
    ),
  );
}
